import ErrorBadge from '@/components/validation/ErrorBadge';
import { useErrorHandler } from '@/hooks/useErrorHandler';
import { Severity, ValidationError } from '@/types/validation';
import { Box, Stack } from '@mui/material';
import { FC, ReactNode, useEffect, useState } from 'react';

type NodeValidatorProps = {
  children?: ReactNode;
  nodeId: number;
};

const NodeValidator: FC<NodeValidatorProps> = ({ children, nodeId }) => {
  const { errors } = useErrorHandler();
  const [currentNodeSeverity, setCurrentNodeSeverity] = useState<Severity>();

  const getSeverity = (currentErrors: ValidationError[]): Severity | undefined => {
    if (currentErrors?.find(({ severity }) => severity === 'error')) return 'error';
    if (currentErrors?.find(({ severity }) => severity === 'warning')) return 'warning';
    if (currentErrors?.find(({ severity }) => severity === 'info')) return 'info';
    return;
  };

  useEffect(() => {
    const currentErrors = errors.filter((error) => error.id === nodeId);
    setCurrentNodeSeverity(getSeverity(currentErrors));
  }, [errors]);

  return (
    <Box position='relative'>
      <Stack sx={{ position: 'absolute', bottom: 0, p: 0.5 }}>
        {currentNodeSeverity && <ErrorBadge severity={currentNodeSeverity} rounded outlined />}
      </Stack>
      {children}
    </Box>
  );
};

export default NodeValidator;
